import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { featuredTestimonial, testimonials } from '../data/testimonials';
import { offer } from '../data/offer';
const stats = [{
  label: 'বাংলাদেশের শিক্ষার্থী',
  value: offer.studentCount
}, {
  label: 'সন্তুষ্টির হার',
  value: offer.satisfaction
}, {
  label: 'মানি-ব্যাক গ্যারান্টি',
  value: '৭ দিন'
}];
export function SocialProof() {
  return <section aria-labelledby="proof-heading" className="border-y border-white/10 bg-navy-900" data-id="element-147" data-mp="3eblr92gxnxi">
      <div className="mx-auto max-w-content px-4 py-10 sm:px-6 lg:py-12" data-id="element-148" data-mp="8dogefzkzzan">
        <h2 id="proof-heading" className="max-w-2xl font-display text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-3xl" data-id="element-149" data-mp="8fsjivpnou9v">
          বাংলাদেশের {offer.studentCount} শিক্ষার্থীর সাথে যোগ দিন, যারা ইতিমধ্যেই নিজেদের জীবন
          বদলে ফেলছেন
        </h2>

        <div className="mt-8 grid gap-4 lg:grid-cols-3" data-id="element-150" data-mp="mcefu29vib26">
          <figure className="flex h-full flex-col rounded-xl border border-celeste-500/30 bg-navy-800 p-6 lg:col-span-2" data-id="element-151" data-mp="r4pfr54m5wuq">
            <QuoteIcon className="h-6 w-6 text-celeste-500" aria-hidden="true" data-id="element-152" data-mp="1uamn3x1rlpyy" />
            <blockquote className="mt-4 font-display text-base font-semibold leading-snug text-white sm:text-lg" data-id="element-153" data-mp="1pbjhaadynfpx">
              &ldquo;{featuredTestimonial.quote}&rdquo;
            </blockquote>
            <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-154" data-mp="1z8o3293w9967">
              <img src={featuredTestimonial.avatar} alt={`${featuredTestimonial.name}-এর ছবি`} width={44} height={44} loading="lazy" decoding="async" className="h-11 w-11 rounded-full object-cover" data-id="element-155" data-mp="2d0chwk5j2bqv" />
              <div data-id="element-156" data-mp="2myii8xbor9tm">
                <p className="text-sm font-semibold text-white" data-id="element-157" data-mp="2mys7giowpcy9">
                  {featuredTestimonial.name}
                  <span className="font-normal text-white/55" data-id="element-158" data-mp="2i0gwu5qseyez">
                    {' '}
                    · {featuredTestimonial.location}
                  </span>
                </p>
                <p className="mt-0.5 text-[13px] font-semibold text-celeste-300" data-id="element-159" data-mp="nm67zxa70497">
                  {featuredTestimonial.role}
                </p>
              </div>
            </figcaption>
          </figure>

          <dl className="flex h-full flex-col justify-center gap-5 rounded-xl border border-white/10 bg-navy-800/50 p-6" data-id="element-160" data-mp="1hc6n9uum5pyn">
            {stats.map(stat => <div key={stat.label} data-id="element-161" data-mp="1mcb5bpb66sqz">
                <dt className="text-[11px] font-semibold uppercase tracking-[0.16em] text-white/45" data-id="element-162" data-mp="1r9ujkp7vb5ix">
                  {stat.label}
                </dt>
                <dd className="mt-0.5 font-display text-2xl font-extrabold tabular-nums text-white sm:text-3xl" data-id="element-163" data-mp="1w85uz4dt9o39">
                  {stat.value}
                </dd>
              </div>)}
          </dl>
        </div>

        <div className="mt-4 grid gap-4 md:grid-cols-3" data-id="element-164" data-mp="252sszfh5ay5h">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-xl border border-white/10 bg-navy-800/60 p-5" data-id="element-165" data-mp="29z13ugob856u">
              <blockquote className="text-[13px] leading-relaxed text-white/80" data-id="element-166" data-mp="2ex2qfbky2mn2">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-5" data-id="element-167" data-mp="8ber9nf0hqbj">
                <img src={item.avatar} alt={`${item.name}-এর ছবি`} width={36} height={36} loading="lazy" decoding="async" className="h-9 w-9 shrink-0 rounded-full object-cover" data-id="element-168" data-mp="3b0qmqfqpinj" />
                <div className="min-w-0" data-id="element-169" data-mp="3pis3sgmlixjv">
                  <p className="text-[13px] font-semibold text-white" data-id="element-170" data-mp="3pk2133lmk1pg">
                    {item.name}
                    <span className="font-normal text-white/55" data-id="element-171" data-mp="qztjuf4z9ceg"> · {item.location}</span>
                  </p>
                  <p className="text-[13px] text-celeste-300" data-id="element-172" data-mp="m2jsgty12qnz">{item.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}